module.exports = __webpack_public_path__ + "img/BateriaAlerta.39847dc8.svg";